import { useFormContext, UseFormProps, UseFormReturn } from "react-hook-form";

import Linkify from 'linkify-react'

import { Box, Card, CardContent, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'

// import { CheckboxInput } from "../components/CheckboxInput";
import { SwitchInput } from "../components/SwitchInput";
import { RadioInput } from "../components/RadioInput";

export interface IConsentFormProps {
  title?: string
  text?: string
  name?: string

  title2?: string
  text2?: string
  name2: string

  title3?: string
  text3?: string
  name3: string

  title4?: string
  text4?: string
  name4?: string

  title5?: string
  text5?: string
  name5?: string

  readonly?: boolean
}


export const ConsentForm = (props: IConsentFormProps) => {

  const linkifyOptions = {
    target: '_blank',
    style: { color: '#ff0000' },
    attributes: {
      onClick: (event: Event, i: any) => {
        // alert('hallo')
        console.log(i)
      }
    }
  }
  const form: UseFormReturn<IConsentFormProps, UseFormProps> = useFormContext();


  // TODO mediaFlag
  return (
    <Box sx={{ minWidth: 275, mt: 1 }}>
      <Card variant="outlined" sx={{ backgroundColor: '#EAF2F1', borderRadius: .6 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ ml: 3 }}>{props.title}</Typography>
          <Grid container spacing={1}>

            {props.name && <Grid xs={12}>
              <SwitchInput
                hidden={true}
                name={props.name}
                label={
                  <Linkify options={linkifyOptions}>
                    {props.text}
                  </Linkify>
                } />
            </Grid>}

            {props.name3 && <Grid xs={12}>
              <SwitchInput
                hidden={true}
                name={props.name3}
                label={
                  <Linkify options={linkifyOptions}>
                    {props.text3}
                  </Linkify>
                } />
            </Grid>}

            {props.name2 && <Grid xs={12}>
              <RadioInput
                hidden={true}
                name={props.name2}
                label={
                  <Linkify options={linkifyOptions}>
                    {props.text2}
                  </Linkify>
                } />
            </Grid>}

            {props.name4 && <Grid xs={12}>
              <RadioInput
                hidden={true}
                name={props.name4}
                label={
                  <Linkify options={linkifyOptions}>
                    {props.text4}
                  </Linkify>
                } />
            </Grid>}

            {props.name5 && <Grid xs={12}>
              <RadioInput
                hidden={true}
                name={props.name5}
                label={
                  <Linkify options={linkifyOptions}>
                    {props.text5}
                  </Linkify>
                } />
            </Grid>}

          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}